export type ZendeskViaChannelIdType =
  | 'ZENDESK_VIA_CHANNEL_ID_UNKNOWN'
  | 'WEB_FORM'
  | 'MAIL'
  | 'WEB_SERVICE'
  | 'VOICEMAIL'
  | 'PHONE_CALL_INBOUND'
  | 'PHONE_CALL_OUTBOUND';

/**
 * An enum for Zendesk's `via_id` field on `ZendeskTicket`s. Note that these values don't directly correspond to `via_id`
 * values as expected by Zendesk. See com.faire.vendor.zendesk.ZendeskViaChannelIdExtensions.kt for details.
 */
export enum ZendeskViaChannelId {
  ZENDESK_VIA_CHANNEL_ID_UNKNOWN = 'ZENDESK_VIA_CHANNEL_ID_UNKNOWN',
  WEB_FORM = 'WEB_FORM',
  MAIL = 'MAIL',
  WEB_SERVICE = 'WEB_SERVICE',
  VOICEMAIL = 'VOICEMAIL',
  PHONE_CALL_INBOUND = 'PHONE_CALL_INBOUND',
  PHONE_CALL_OUTBOUND = 'PHONE_CALL_OUTBOUND',
}
